import { appManager, AppState } from '../manager';
import {
  addElementToIndexedArray,
  arrayToIndexedObject,
} from 'services/indexedObject';

import * as types from '../types';

export const fetchKlasses = appManager.createApi<
  unknown,
  types.Klass[],
  AppState
>('FETCH_KLASSES', {
  path: '/klasses',
  method: 'GET',
  successReducer(state, result) {
    state.klasses.items = arrayToIndexedObject(result);
  },
});

// Admin-only lightweight list of every class + its trainer, for the cross-trainer
// "Replay into..." target picker in the admin Sessions table.
export const fetchReplayTargetKlasses = appManager.createApi<
  unknown,
  types.ReplayTargetKlass[],
  AppState
>('FETCH_REPLAY_TARGET_KLASSES', {
  path: '/klasses/replay_targets',
  method: 'GET',
  startReducer(state) {
    state.replay_target_klasses.waiting = true;
  },
  successReducer(state, result) {
    state.replay_target_klasses = {
      items: result,
      waiting: false,
      fetched: true,
    };
  },
  failReducer(state) {
    state.replay_target_klasses.waiting = false;
  },
});

export const fetchPersons = appManager.createApi<
  unknown,
  types.Person[],
  AppState
>('FETCH_PERSONS', {
  path: '/persons',
  method: 'GET',
  successReducer(state, result) {
    state.persons.items = arrayToIndexedObject(result);
  },
});

export const createPerson = appManager.createApi<
  { name: string },
  types.Person,
  AppState
>('CREATE_PERSON', {
  path: '/persons',
  method: 'POST',
  successReducer(state, result) {
    addElementToIndexedArray(state.persons.items, result);
  },
});

export const createKlass = appManager.createApi<
  types.CreateKlassPayload,
  types.Klass,
  AppState
>('CREATE_KLASS', {
  path: '/klasses',
  method: 'POST',
  startReducer(state) {
    state.create_klass_waiting = true;
  },
  successReducer(state, result) {
    state.create_klass_waiting = false;
    addElementToIndexedArray(state.klasses.items, result);
  },
  failReducer(state) {
    state.create_klass_waiting = false;
  },
});
